import { Node } from "reactflow";

export const createNode = ({
  id,
  type,
  position,
  header,
  borderColor,
  shadowColor,
  iconStyle,
  extraData = {},
  onDelete,
  onDataChange,
}: any): Node => {
  return {
    id,
    type,
    position,
    data: {
      header,
      borderColor,
      shadowColor,
      iconStyle,
      ...extraData,
      onDelete,
      onDataChange,
    },
  };
};
